import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserInfo } from 'types';

export type AuthStore = {
  userInfo: UserInfo | null;
};

const initialState: AuthStore = {
  userInfo: null
};

export const persistAuthSlice = createSlice({
  name: 'persistAuth',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfo | null>) => {
      state.userInfo = action.payload;
    }
  }
});

export const { setUserInfo } = persistAuthSlice.actions;

export default persistAuthSlice.reducer;
